import api from './index'

/**
 * 用户登录
 * @param {Object} data 登录数据
 * @param {string} data.username 用户名
 * @param {string} data.password 密码
 * @returns {Promise}
 */
export const login = (data) => {
  return api.post('/api/auth/login', data)
}

/**
 * 用户注册
 * @param {Object} data 注册数据
 * @param {string} data.username 用户名
 * @param {string} data.phone 手机号
 * @param {string} data.password 密码
 * @returns {Promise}
 */
export const register = (data) => {
  return api.post('/api/auth/register', data)
}

/**
 * 获取当前用户详情
 * @returns {Promise}
 */
export const getCurrentUser = () => {
  return api.get('/api/auth/me')
}

// 注意：充值功能已迁移到 payment.js 模块
// 以下函数保留以兼容旧代码，建议逐步替换为 payment.createPayment

/**
 * 退出登录
 * @returns {Promise}
 */
export const logout = () => {
  return api.post('/auth/logout')
}